
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"moduleProductsUpgradeCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whitelabel_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"current_purchase_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"new_product_uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billing_cycle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moduleProductsUpgradeCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"whitelabel_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whitelabel_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"current_purchase_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"current_purchase_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"new_product_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"new_product_uuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"billing_cycle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billing_cycle"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payee_logo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fees"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"penalty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"note"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payment_gateway"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gateway_wallet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"txn_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billing_from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billing_to"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"crypto_payment_started_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fiat_payment_started_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"due_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_paid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"module_products_order_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updated_at"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":706}};
    doc.loc.source = {"body":"mutation moduleProductsUpgradeCheckout(\n  $whitelabel_uuid: ID!\n  $current_purchase_uuid: ID!\n  $new_product_uuid: ID!\n  $billing_cycle: String!\n) {\n  moduleProductsUpgradeCheckout(\n    whitelabel_uuid: $whitelabel_uuid\n    current_purchase_uuid: $current_purchase_uuid\n    new_product_uuid: $new_product_uuid\n    billing_cycle: $billing_cycle\n  ) {\n    id\n    tag\n    payee_logo\n    payee\n    payer\n    fees\n    taxes\n    penalty\n    total\n    currency\n    status\n    note\n    payment_gateway\n    gateway_wallet\n    txn_id\n    billing_from\n    billing_to\n    crypto_payment_started_at\n    fiat_payment_started_at\n    due_date\n    date_paid\n    module_products_order_id\n    created_at\n    updated_at\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["moduleProductsUpgradeCheckout"] = oneQuery(doc, "moduleProductsUpgradeCheckout");
        
